import axios from "axios";

const publicAxios = axios.create({
    
});

export default publicAxios;